var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.props.subcomponent,{ref:_vm.props.subcomponent_props.id,tag:"component",attrs:{"id":_vm.props.subcomponent_props.id,"props":_vm.props.subcomponent_props}})}
var staticRenderFns = []

export { render, staticRenderFns }